import { Navigate } from 'react-router-dom'

import { Loader } from '@UI/Loader'

import { useGetInfoAbutMeQuery } from '@store/profile/profile.api'

import { RolePermissionGuardProps } from './RolePermissionGuard.props'

export function RolePermissionGuard({ children, role, permission, withRedirect, withText }: RolePermissionGuardProps) {
  const { data, isLoading } = useGetInfoAbutMeQuery({})

  if (isLoading) return <Loader />

  const userRole = data?.role
  const userPermissions = data?.permissions ?? []

  const hasRole = !role || (Array.isArray(role) ? !!userRole && role.includes(userRole) : userRole === role)

  const hasPermission =
    !permission || (Array.isArray(permission) ? permission.some((perm) => userPermissions.some((p) => p.id === perm)) : userPermissions.some((p) => p.id === permission))

  if (!hasRole || !hasPermission) {
    return withRedirect ? (
      <Navigate
        to="/"
        replace
      />
    ) : withText ? (
      <>У Вас немає відповідного дозволу</>
    ) : null
  }

  return <>{children}</>
}
